module.exports = __webpack_public_path__ + "static/media/Frame (4).d3954435.png";